import { Deserializable } from '../../protocols/deserializable';
import { Attachment } from '../attachment';

export class EmployerSubmissionAttachment implements Deserializable {
  public id!: string;
  public employerSubmissionId!: string;
  public attachment!: Attachment;
  public uploadedDuringSubmission!: boolean;

  public onDeserialize(): void {
    if (!!this.attachment) {
      this.attachment = window.injector.Deserialize.instanceOf(Attachment, this.attachment);
    }
  }
}
